import {
  formatNumbersStr,
  Group,
  GroupSubscription,
  SubscriptionPrice,
} from '@intly/core';
import { FC } from 'react';
import * as FileSaver from 'file-saver';

import {
  BlobProvider,
  PDFViewer,
  Path,
  Svg,
  Document,
  Page,
  Text,
  View,
  StyleSheet,
} from '@react-pdf/renderer';
import { useTranslation } from 'react-i18next';
import { IconButton, Tooltip } from '@mui/material';
import { IoDownloadOutline } from 'react-icons/io5';
import { DateTime } from 'luxon';

const AgreementLogo: React.FC<ElementsProps> = ({ owner }) => {
  if (owner === 'Aqord') {
    return (
      <View
        style={{
          height: 75,
        }}
      >
        <Text
          style={{
            fontSize: 30,
            color: 'rgba(181,15,115, 1)',
            // textAlign: 'center',
            fontWeight: 'bold',
            marginTop: 20,
            marginLeft: 30,
          }}
        >
          aQord
        </Text>
      </View>
    );
  }

  return (
    <Svg width="190" height="95" viewBox="0 0 760 380">
      <Path d="M112 224H196.518V249.229H112V224Z" fill="#8A56AC" />
      <Path
        fillRule="evenodd"
        // clipRule="evenodd"
        d="M154.857 212.022C139.532 212.022 127.058 207.567 117.435 198.657C107.812 189.747 103 178.698 103 165.511C103 152.324 107.812 141.276 117.435 132.365C127.058 123.455 139.532 119 154.857 119C170.183 119 182.657 123.277 192.28 131.831C201.903 140.384 206.715 151.077 206.715 163.907C206.715 177.807 201.903 189.391 192.28 198.657C182.657 207.567 170.183 212.022 154.857 212.022ZM154.847 188.364C147.208 188.364 140.991 186.143 136.194 181.702C131.398 177.261 129 171.755 129 165.182C129 158.609 131.398 153.102 136.194 148.661C140.991 144.22 147.208 142 154.847 142C162.485 142 168.702 144.132 173.499 148.395C178.295 152.658 180.693 157.988 180.693 164.383C180.693 171.311 178.295 177.084 173.499 181.702C168.702 186.143 162.485 188.364 154.847 188.364Z"
        fill="#8A56AC"
      />
      <Path
        d="M255 122.007C255 117.383 256.652 113.588 259.956 110.624C263.261 107.541 267.627 106 273.056 106C278.484 106 282.85 107.541 286.155 110.624C289.459 113.588 291.111 117.383 291.111 122.007C291.111 126.512 289.459 130.306 286.155 133.389C282.85 136.353 278.484 137.836 273.056 137.836C267.627 137.836 263.261 136.353 259.956 133.389C256.652 130.306 255 126.512 255 122.007Z"
        fill="#1F1F1F"
      />
      <Path
        d="M467 128.174C466.941 143.355 462.664 155.724 454.17 165.28C445.616 174.903 434.924 179.715 422.093 179.715C421.668 179.715 421.246 179.71 420.826 179.701L420.826 153.683C421.088 153.69 421.352 153.693 421.618 153.693C428.013 153.693 433.342 151.295 437.605 146.499C441.807 141.771 443.939 135.663 443.999 128.174L467 128.174Z"
        fill="#1F1F1F"
      />
      <Path
        d="M484.272 222.767V248.911H470.642C459.077 248.911 450.049 246.066 443.559 240.374C437.186 234.565 434 225.02 434 211.74V175.28V149.67H464.27H484.095V175.28H464.27V212.274C464.27 216.186 465.037 218.914 466.571 220.455C468.223 221.996 470.937 222.767 474.714 222.767H484.272Z"
        fill="#1F1F1F"
      />
      <Path d="M531.555 128V248.911H501.285V128H531.555Z" fill="#1F1F1F" />
      <Path
        d="M484.272 222.767V248.911H470.642C459.077 248.911 450.049 246.066 443.559 240.374C437.186 234.565 434 225.02 434 211.74V175.28V149.67H464.27H484.095V175.28H464.27V212.274C464.27 216.186 465.037 218.914 466.571 220.455C468.223 221.996 470.937 222.767 474.714 222.767H484.272Z"
        fill="#1F1F1F"
      />
      <Path d="M531.555 128V248.911H501.285V128H531.555Z" fill="#1F1F1F" />
      <Path
        d="M371.664 148C382.993 148 391.961 151.794 398.57 159.383C405.297 166.971 408.66 177.405 408.66 190.685V248.309H378.39V194.242C378.39 187.602 376.62 182.444 373.08 178.768C369.657 174.974 365.055 173.077 359.272 173.077C353.136 173.077 348.238 175.034 344.58 178.946C341.04 182.859 339.27 188.432 339.27 195.664V248.309H309V149.067H339.27V167.208C342.102 161.28 346.291 156.596 351.838 153.158C357.502 149.719 364.111 148 371.664 148Z"
        fill="#1F1F1F"
      />
      <Path d="M288.27 249.242V150H258V249.242H288.27Z" fill="#1F1F1F" />
      <Path
        d="M657.74 150L615.62 251.52C610.7 263.52 604.7 271.92 597.62 276.72C590.54 281.64 581.9 284.1 571.7 284.1C566.54 284.1 561.32 283.26 556.04 281.58C550.88 280.02 546.68 277.92 543.44 275.28L555.32 251.34C557.24 253.14 559.52 254.52 562.16 255.48C564.92 256.56 567.68 257.1 570.44 257.1C573.68 257.1 576.32 256.44 578.36 255.12C580.52 253.8 582.32 251.7 583.76 248.82L542 150H577.1L601.04 209.58L625.16 150H657.74Z"
        fill="#1F1F1F"
      />
    </Svg>
  );
};

interface ElementsProps {
  owner?: string | null;
}

const s = StyleSheet.create({
  page: {
    flexDirection: 'column',
    backgroundColor: '#FFF',
    wordBreak: 'keep-all',
    // margin: 10,
    fontSize: 12,
  },
  header: {
    fontSize: 10,
  },
  headerAddress: {
    marginLeft: 30,
    marginTop: -20,
  },
  address: {
    // alignSelf: 'flex-end',
    // margin: 10,
    marginTop: 0,
    marginBottom: 0,
  },
  invoiceHeader: {
    fontSize: 30,
    fontWeight: 200,
  },
  splitSection: {
    flexDirection: 'row',
    margin: 20,
    marginHorizontal: 20,
  },
  splitSectionItem: {
    flex: 0.5,
    padding: 10,
  },
  section: {
    margin: 10,
    padding: 10,
    flexGrow: 1,
  },
  paymentInfoRow: {
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  paymentDetailRowItem: {
    // width: '100%',
    flexGrow: 1,
    borderBottom: '1px solid #000',
    marginBottom: 10,
  },
  footer: {
    flexDirection: 'row',
    marginHorizontal: 30,
    marginBottom: 30,
    fontSize: 10,
    justifyContent: 'space-evenly',
    // alignSelf: 'flex-end',
  },
});

const PageFooter: React.FC<AgreementProps> = ({ group }) => {
  return (
    <View style={[s.footer]}>
      <Text>Orgnr: {group?.customerOf?.orgNo ?? '559253-8820'}</Text>
      <View style={{ borderRight: '1px solid #000' }} />
      <Text>Bankgiro: {group?.customerOf?.bankGiro ?? '5497-7061'}</Text>
      <View style={{ borderRight: '1px solid #000' }} />

      <Text>Vat nr: {group?.customerOf?.vatNo ?? 'SE559253882001'}</Text>
      <View style={{ borderRight: '1px solid #000' }} />

      <Text>Säte: Stockholm</Text>
      <View style={{ borderRight: '1px solid #000' }} />

      <Text>Godkänd för F-skatt</Text>
    </View>
  );
};

// interface SpecificationSectionProps extends AgreementProps {}

const SpecificationSection: FC<AgreementProps> = ({ subscription }) => {
  const { t } = useTranslation();
  const price = subscription?.price ?? ({} as SubscriptionPrice);

  return (
    <>
      <View
        style={{
          flexDirection: 'row',
          justifyContent: 'space-between',
          fontSize: 10,
        }}
      >
        <View style={{ flex: 1 }}>
          <Text style={s.paymentDetailRowItem}>Prenumation</Text>
          <Text style={{ marginBottom: 5 }}>{subscription?.name}</Text>
          <Text style={{ borderTop: '1px solid #000', paddingTop: 5 }}> </Text>
        </View>

        <View style={{ flex: 1 }}>
          <Text style={s.paymentDetailRowItem}>Från</Text>
          <Text style={{ marginBottom: 5 }}>
            {subscription?.start &&
              DateTime.fromSeconds(subscription?.start).toFormat('yyyy-MM-dd')}
          </Text>
          <Text style={{ borderTop: '1px solid #000', paddingTop: 5 }}> </Text>
        </View>
        <View>
          <Text style={[s.paymentDetailRowItem, { paddingRight: 10 }]}>
            Till
          </Text>
          <Text style={{ marginBottom: 5 }}>
            {subscription?.end
              ? DateTime.fromSeconds(subscription?.start).toFormat('yyyy-MM-dd')
              : '-'}
          </Text>
          <Text style={{ borderTop: '1px solid #000', paddingTop: 5 }}> </Text>
        </View>
        <View>
          <Text style={[s.paymentDetailRowItem]}>Förnyas automatiskt</Text>
          <Text style={{ marginBottom: 5 }}>
            {!subscription?.price.renew
              ? t('NO')
              : `${subscription?.price.interval} ${t('MONTH', {
                  count: subscription?.price.interval,
                }).toLowerCase()}`}
          </Text>
          <Text style={{ borderTop: '1px solid #000', paddingTop: 5 }}> </Text>
        </View>
      </View>
      <View
        style={{
          flexDirection: 'row',
          justifyContent: 'space-between',
          fontSize: 10,
        }}
      >
        <View style={{ flex: 1 }}>
          <Text
            style={{
              ...s.paymentDetailRowItem,
              borderBottom: '0.5px solid #000',
            }}
          ></Text>
          <Text style={{ marginBottom: 5 }}>{subscription?.name}</Text>
          {Boolean(price.discount) && (
            <Text style={{ marginBottom: 5 }}>{`${subscription?.name} (${t(
              'DISCOUNT'
            )})`}</Text>
          )}
          <Text style={{ borderTop: '0.5px solid #000', paddingTop: 5 }}>
            {' '}
          </Text>
        </View>
        <View style={{ flex: 1 }}>
          <Text
            style={{
              ...s.paymentDetailRowItem,
              borderBottom: '0.5px solid #000',
            }}
          >
            Detaljer
          </Text>
          <Text style={{ marginBottom: 5 }}>
            {price.users > 0 ? `${t('USER_plural')}: ${price.users} st` : ''}
            {price.employees > 0
              ? `${t('EMPLOYEE_plural')}: ${price.employees} st`
              : ''}
            {Boolean(price.discount) && (
              <Text style={{ marginBottom: 5 }}>{price.employees}</Text>
            )}
          </Text>
          <Text style={{ borderTop: '0.5px solid #000', paddingTop: 5 }}>
            {' '}
          </Text>
        </View>
        <View>
          <Text
            style={{
              ...s.paymentDetailRowItem,
              borderBottom: '0.5px solid #000',
            }}
          >
            Pris
          </Text>
          <Text style={{ marginBottom: 5 }}>
            {formatNumbersStr(price.subtotal, 2)} kr
          </Text>
          {Boolean(price.discount) && (
            <Text style={{ marginBottom: 5 }}>{price.discount}</Text>
          )}
          <Text style={{ borderTop: '0.5px solid #000', paddingTop: 5 }}>
            {' '}
          </Text>
        </View>
      </View>

      {/* {Boolean(price?.extra) && (
        <>
          {(price?.extra ?? []).map((e) => {
            // const extraSub = extra.find((x) => x.id === e.id);
            // const isEmployees = extraSub?.propertys.some(
            //   (p) => p.key === 'employees' && p.value
            // );
            // const isUser = extraSub?.propertys.some(
            //   (p) => p.key === 'users' && p.value
            // );

            // let text = '';
            // if (isEmployees) {
            //   text = `${e.employees}st`;
            // } else if (isUser) {
            //   const role = extraSub?.propertys.find((p) => p.key)?.value;
            //   text = `${t(role)}`;
            // }
            return (
              <View
                style={{
                  flexDirection: 'row',
                  justifyContent: 'space-between',
                  fontSize: 10,
                }}
              >
                <View style={{ flex: 1 }}>
                  <Text style={s.paymentDetailRowItem}></Text>
                  <Text style={{ marginBottom: 5 }}>{subscription?.name}</Text>
                  {Boolean(price.discount) && (
                    <Text style={{ marginBottom: 5 }}>{`${
                      subscription?.name
                    } (${t('DISCOUNT')})`}</Text>
                  )}
                  <Text style={{ borderTop: '1px solid #000', paddingTop: 5 }}>
                    {' '}
                  </Text>
                </View>
                <View style={{ flex: 1 }}>
                  <Text style={s.paymentDetailRowItem}>Detlajer</Text>
                  <Text style={{ marginBottom: 5 }}>
                    {price.users > 0
                      ? `${t('USER_plural')}: ${price.users} st`
                      : ''}
                    {price.employees > 0
                      ? `${t('EMPLOYEE_plural')}: ${price.employees} st`
                      : ''}
                    {Boolean(price.discount) && (
                      <Text style={{ marginBottom: 5 }}>{price.employees}</Text>
                    )}
                  </Text>
                  <Text style={{ borderTop: '1px solid #000', paddingTop: 5 }}>
                    {' '}
                  </Text>
                </View>
                <View>
                  <Text style={[s.paymentDetailRowItem]}>Pris</Text>
                  <Text style={{ marginBottom: 5 }}>{price.subtotal}</Text>
                  {Boolean(price.discount) && (
                    <Text style={{ marginBottom: 5 }}>{price.discount}</Text>
                  )}
                  <Text style={{ borderTop: '1px solid #000', paddingTop: 5 }}>
                    {' '}
                  </Text>
                </View>
              </View>
            );
          })}
        </>
      )} */}
      {/* <View
        style={{
          flexDirection: 'row',
          justifyContent: 'space-between',
          fontSize: 10,
        }}
      >
        <View style={{ flex: 1 }}>
          <Text style={s.paymentDetailRowItem}></Text>
          <Text style={{ marginBottom: 5 }}>
            {t('VAT')} 25% {formatNumbersStr(price.totalVat, 2)} kr
          </Text>
          <Text style={{ borderTop: '1px solid #000', paddingTop: 5 }}> </Text>
        </View>
        <View style={{ flex: 1 }}>
          <Text style={{ marginBottom: 5 }}>
            {t(price.isPrivate ? 'SUBTOTAL_NET' : 'SUBTOTAL_BRUTTO')}
            {formatNumbersStr(
              price.isPrivate ? price.totalNet : price.total,
              2
            )}{' '}
            kr
          </Text>
          {Boolean(price.totalDiscount) && (
            <Text style={{ marginBottom: 5 }}>
              {t('TOTAL_DISCOUNT')}{' '}
              {`-${formatNumbersStr(price.totalDiscount || 0, 2)}`} kr
            </Text>
          )}
          <Text style={{ borderTop: '1px solid #000', paddingTop: 5 }}> </Text>
        </View>
        <View>
          <Text style={{ marginBottom: 5 }}>
            {t('TOTAL_FOR_PERIOD')}{' '}
            {formatNumbersStr(
              price.isPrivate ? price.total : price.totalNet,
              2
            )}{' '}
            kr
          </Text>
          <Text style={{ borderTop: '1px solid #000', paddingTop: 5 }}> </Text>
        </View>
      </View> */}
    </>
  );
};

export interface AgreementProps {
  group?: Group | null;
  subscription?: GroupSubscription;
}

const Agreement: FC<AgreementProps> = ({ subscription, group }) => {
  return (
    <Document title={'Avtal'}>
      <Page size="A4" style={s.page}>
        <View style={s.header}>
          <AgreementLogo owner={group?.customerOf?.name} />
          <View style={[s.headerAddress]}>
            <Text>
              {group?.customerOf?.name
                ? `${group?.customerOf?.name} AB`
                : 'Intly AB'}
            </Text>
            <Text>{group?.customerOf?.address ?? 'Gustavslundsvägen 12'}</Text>
            <Text>
              {group?.customerOf?.postalCode ?? '167 51'}{' '}
              {group?.customerOf?.city ?? 'Bromma'}
            </Text>
          </View>
        </View>

        <View
          style={[
            s.section,
            { marginHorizontal: 10, marginTop: 10, flex: 1 },
            { marginTop: 50 },
          ]}
        >
          <View style={[]}>
            <Text style={[s.invoiceHeader, { alignSelf: 'center' }]}>
              Avtal
            </Text>
            <View style={{ fontSize: 10, marginTop: 10 }}>
              <Text style={{ textAlign: 'center' }}>{group?.name}</Text>
              <Text style={{ marginVertical: 20 }}>
                Intly Education är en prenumerationsbaserad utbildningstjänst
                inom lön och som ger användaren tillgång till både
                live-föreläsningar och förinspelade utbildningar. Tjänsten
                syftar till att erbjuda kontinuerlig kompetensutveckling för
                löneprofessionella, med flexibla möjligheter att ta del av
                innehållet när och var det passar. Genom prenumerationen
                säkerställs en löpande tillgång till aktuellt, kvalitetssäkrat
                material och interaktiva utbildningstillfällen.
                {/* {group?.customerOf?.name ?? 'Intly'}. */}
              </Text>
            </View>
            <View style={{ fontSize: 10, marginTop: 10 }}>
              <Text style={{ marginVertical: 20 }}>
                För fullständiga användarvillkor och datapolicy läs mer på:{' '}
                <Text style={{ color: '#0000EE' }}>
                  https://www.intly.se/privacy-policy/
                </Text>
                {/* {group?.customerOf?.name ?? 'Intly'}. */}
              </Text>
              <Text style={{ marginVertical: 20 }}></Text>
            </View>
          </View>
        </View>

        <View
          style={[s.section, { marginHorizontal: 10, marginTop: 10, flex: 1 }]}
        >
          <Text style={{ fontSize: 18, marginBottom: 5 }}>Specifikation</Text>
          <SpecificationSection subscription={subscription} />
        </View>

        <View
          style={[s.section, { marginHorizontal: 10, marginTop: 10, flex: 1 }]}
        >
          <Text style={{ fontSize: 13, marginBottom: 5 }}>
            Kundens uppgifter
          </Text>
          <View
            style={{
              flexDirection: 'row',
              justifyContent: 'space-between',
              fontSize: 8,
            }}
          >
            <View style={{ flex: 1 }}>
              <Text style={{ flexGrow: 1, marginBottom: 10 }}>Kund</Text>
              <Text style={{ marginBottom: 5 }}>
                {group?.billing?.isPrivate
                  ? `${group?.billing?.firstName} ${group?.billing?.lastName}`
                  : group?.billing?.companyName}
              </Text>
            </View>
            <View style={{ flex: 1 }}>
              <Text style={{ flexGrow: 1, marginBottom: 10 }}>
                Organistationsnummer
              </Text>
              <Text style={{ marginBottom: 5 }}>{group?.billing?.orgNo}</Text>
            </View>
            <View style={{ flex: 1 }}>
              <Text style={{ flexGrow: 1, marginBottom: 10 }}>Referens</Text>
              <Text style={{ marginBottom: 5 }}>
                {group?.billing?.reference}
              </Text>
            </View>
            <View style={{ flex: 1 }}>
              <Text style={{ flexGrow: 1, marginBottom: 10 }}>Epost</Text>
              <Text style={{ marginBottom: 5 }}>{group?.billing?.email}</Text>
            </View>
          </View>
          <View
            style={{
              flexDirection: 'row',
              justifyContent: 'space-between',
              fontSize: 10,
              marginTop: 20,
            }}
          >
            <View style={{ flex: 1 }}>
              <Text style={{ flexGrow: 1, marginBottom: 10 }}>Adress</Text>
              <Text style={{ marginBottom: 5 }}>{group?.billing?.address}</Text>
            </View>
            <View style={{ flex: 1 }}>
              <Text style={{ flexGrow: 1, marginBottom: 10 }}>Postnummer</Text>
              <Text style={{ marginBottom: 5 }}>
                {group?.billing?.postalCode}
              </Text>
            </View>
            <View style={{ flex: 1 }}>
              <Text style={{ flexGrow: 1, marginBottom: 10 }}>Stad</Text>
              <Text style={{ marginBottom: 5 }}>{group?.billing?.city}</Text>
            </View>
            <View style={{ flex: 1 }}>
              <Text style={{ flexGrow: 1, marginBottom: 10 }}> </Text>
              <Text style={{ marginBottom: 5 }}> </Text>
            </View>
          </View>
        </View>

        <PageFooter group={group} />
      </Page>
    </Document>
  );
};

export const AgreementPreview: FC<AgreementProps> = ({
  subscription,
  group,
}) => {
  return (
    <PDFViewer
      style={{
        height: '1000px',
        width: '100%',
      }}
    >
      <Agreement subscription={subscription} group={group} />
    </PDFViewer>
  );
};

export const AgreementDownload: FC<AgreementProps> = ({
  subscription,
  group,
}) => {
  const { t } = useTranslation();

  const invoiceName = 'Avtal.pdf'; //useAgreementName({ subscription, group });
  return (
    <BlobProvider
      document={<Agreement subscription={subscription} group={group} />}
    >
      {({ blob, url, loading, error }) =>
        loading || blob === null ? (
          <IconButton disabled size="small">
            <IoDownloadOutline />
          </IconButton>
        ) : (
          <Tooltip title={t('DOWNLOAD')}>
            <IconButton
              size="small"
              onClick={() => {
                FileSaver.saveAs(blob, invoiceName);
              }}
            >
              <IoDownloadOutline />
            </IconButton>
          </Tooltip>
        )
      }
    </BlobProvider>
  );
};

export default AgreementPreview;
